import Choices from 'choices.js';
import '../../../../node_modules/choices.js/public/assets/styles/choices.css';

let categoriesDisplay = 'all';

export const moduleMenus = () => {

	let menuModules = document.querySelector('.m__menus');
	if(menuModules){

        mobileDietaryFilterToggle();
        filterToggle();
        openItemModal();
		menuFilter();
		scrollToCat();
        scrollFilterHighlight();
	}
};


export const openItemModal = () => {
    const itemModalTriggers = document.querySelectorAll('.js-open-item-modal');
    
    itemModalTriggers.forEach(itemModalTrigger => {
        itemModalTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            
            const itemID = e.currentTarget.getAttribute('data-menu-id');
            const container = document.querySelector('.menu-item-modal__content');

            const getFetchData = () => {
                const formData = new FormData();
                formData.append('itemID', itemID);
                formData.append('action', 'ajax_get_menu_item_modal');
                    
                const ajaxData = new URLSearchParams(formData);

                return ajaxData;
            }

            const data = getFetchData();

            fetch(igniteAjax.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: data
            })
            .then((response) => response.text())
            .then((data) => {
                container.innerHTML = data;

                document.querySelector('.menu-item-modal').classList.add('active');
                document.body.classList.add('js__popup-active');
                modalInfoToggle();
            })
            .catch((error) => {
                console.error(error);
            });  
        });
    });

    const itemModalCloseTriggers = document.querySelectorAll('.js-close-item-modal');
    
    itemModalCloseTriggers.forEach(itemModalCloseTrigger => {
        itemModalCloseTrigger.addEventListener('click', function() {
            document.querySelector('.menu-item-modal').classList.remove('active');
            document.body.classList.remove('js__popup-active');
        });
    });
}

openItemModal();

function modalInfoToggle() {

    const toggleIcons = document.querySelectorAll('.js-open-modal-content');
    const modalContents = document.querySelectorAll('.modal-content');

    toggleIcons.forEach(icon => {
        icon.addEventListener('click', function() {
            const modalContent = this.nextElementSibling;

            this.classList.toggle('open');

            if (modalContent.classList.contains('open')) {
                modalContent.classList.remove('open');
                modalContent.style.maxHeight = null;
            } else {
                modalContent.classList.add('open');
                modalContent.style.maxHeight = modalContent.scrollHeight + "px";
            }
        });
    });

    if (window.innerWidth > 768) {
        // Add 'open' class to all toggle icons and modal content elements if parent is not 'menu-item-modal__ingredients'
        toggleIcons.forEach(icon => {
            if (!icon.closest('.menu-item-modal__ingredients')) {
                icon.classList.add('open');
            }
        });
        modalContents.forEach(content => {
            if (!content.closest('.menu-item-modal__ingredients')) {
                content.classList.add('open');
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    } else {
        // Remove 'open' class if screen is larger than 768px
        toggleIcons.forEach(icon => {
            if (!icon.closest('.menu-item-modal__ingredients')) {
                icon.classList.remove('open');
            }
        });
        modalContents.forEach(content => {
            if (!content.closest('.menu-item-modal__ingredients')) {
                content.classList.add('open');
                content.style.maxHeight = null;
            }
        });
    }
}

function scrollFilterHighlight() {

    const menuItems = document.querySelectorAll('.menu__items--cat, .menu__items--subcat');

    // Observer callback function
    const observerCallback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const scrollKey = entry.target.getAttribute('data-scroll-key');
                const isSubcat = entry.target.classList.contains('menu__items--subcat');
                console.log(`Scroll Key: ${scrollKey}, Is Subcat: ${isSubcat}`);

                setActiveFilterPanel(scrollKey, isSubcat); // Apply active state based on scroll key and type
            }
        });
    };

    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver(observerCallback, {
        root: null,   // Use the viewport as the root
        threshold: 0.3  // Trigger when 10% of the element is visible
    });

    // Observe all .menu__items--cat and .menu__items--subcat elements
    menuItems.forEach(item => {
        observer.observe(item);
    });
}

function setActiveFilterPanel(scrollKey, isSubcat = false) {

    if (isSubcat) {
        // Handle the subcat panels
        document.querySelectorAll('.filter-subcat').forEach(panel => {
            panel.classList.remove('open');
        });

        const targetSubcat = document.querySelector(`.filter-subcat[data-scroll-to="${scrollKey}"]`);
        if (targetSubcat) {
            targetSubcat.classList.add('open');
        }
    } else {
        // Handle the main cat panels
        document.querySelectorAll('.menu__filter-panel--cat').forEach(panel => {
            panel.classList.remove('open');
        });

        const targetPanel = document.querySelector(`.js-menu-scroll-to[data-scroll-to="${scrollKey}"]`);
        if (targetPanel) {
            const panelCat = targetPanel.closest('.menu__filter-panel--cat');
            if (panelCat) {
                panelCat.classList.add('open');
            }
        }
    }
}

export const mobileDietaryFilterToggle = () => {
    let dietaryFilterToggle = document.querySelector('.js-open-dietary-filter');

    if ( dietaryFilterToggle ) {
        dietaryFilterToggle.addEventListener('click', (e) => {
            const dietaryFilterContainer = document.querySelector('.menu__sticky-bar');

            if ( dietaryFilterContainer ) {
                dietaryFilterContainer.classList.toggle('open');
            }
        });
    }
}

export const filterToggle = () => {
    let mobileOpenFilter = document.querySelector('.js-open-mobile-filters');

    if ( mobileOpenFilter ) {
        mobileOpenFilter.addEventListener('click', (e) => {
            const filterContainer = document.querySelector('.menu__filter-panel__wrapper');

            if ( filterContainer ) {
                filterContainer.classList.add('show');
            }
        });
    }

    let mobileCloseFilter = document.querySelector('.js-close-menu-filter');

    if ( mobileCloseFilter ) {
        mobileCloseFilter.addEventListener('click', (e) => {
            const filterContainer = document.querySelector('.menu__filter-panel__wrapper');

            if ( filterContainer ) {
                filterContainer.classList.remove('show');
            }
        });
    }
}

export const menuFilter = () => {

	const menuModules = document.querySelectorAll('.menu.module');
   

    if (menuModules.length) {
        menuModules.forEach((menuModule) => {

            const allergenFilters = document.querySelectorAll('input[name="allergens_filter"]');

            allergenFilters.forEach(allergenFilter => {
                allergenFilter.addEventListener('change', (event) => {

                    event.preventDefault();

                    filterMenuItemsByDietaryRequirement();
                    
                });
            });
        })
        
    }
}

menuFilter();

function filterMenuItemsByDietaryRequirement() {

    const allergenFilters = document.querySelectorAll('input[name="allergens_filter"]');

    let filterChecked = 0;
    let checkedAllergens = [];

    allergenFilters.forEach(allergenFilter => {
        if (allergenFilter.checked) {
            allergenFilter.parentElement.classList.add('active');
            filterChecked++;
            checkedAllergens.push(allergenFilter.value);
        } else {
            allergenFilter.parentElement.classList.remove('active');
        }
    });

    document.querySelectorAll('.menu-item').forEach(menuSubcat => {
        if (filterChecked === 0) {
            menuSubcat.classList.remove('hide');
        } else {
            let hasAllCheckedAllergens = checkedAllergens.every(allergen => menuSubcat.classList.contains(allergen));
            if (hasAllCheckedAllergens) {
                menuSubcat.classList.remove('hide');
            } else {
                menuSubcat.classList.add('hide');
            }
        }
    });
}


export const getOffsetTop = (element) => {
  let offsetTop = 0;
  while(element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent;
  }
  return offsetTop;
}



function toggleSubcatsDisplay(trigger) {
    // Trigger the active menu class
    trigger.classList.toggle('active');
        
    // Show menu sub categories
    if ( trigger.nextElementSibling ) {
        trigger.nextElementSibling.classList.toggle('active');
    }
}

function removeActiveSubcatsClass(triggers) {
    triggers.forEach(trigger => {
        trigger.classList.remove('active');

        if ( trigger.nextElementSibling ) {
            trigger.nextElementSibling.classList.remove('active');

            const subCats = trigger.nextElementSibling.querySelectorAll('.menu__filter-menu-cat');

            if ( subCats ) {
                subCats.forEach(cat => {
                    cat.classList.remove('active');
                });
            }
        }
    });
}

export const scrollToCat = () => {
    const triggers = document.querySelectorAll('.js-menu-filter-subcats-toggle');
    const menuFilterCats = document.querySelectorAll('.js-menu-scroll-to');
    const menusContainer = document.querySelector('.js-menu-category-container');
    const filterPanel = document.querySelector('.menu__filter-panel');
    const filterPanelWrapper = document.querySelector('.menu__filter-panel__wrapper');
    
    menuFilterCats.forEach(menuFilterCat => {
        menuFilterCat.addEventListener('click', (e) => {
            e.preventDefault();

            if (filterPanelWrapper.classList.contains('show')) {
                filterPanelWrapper.classList.remove('show');
            }
            
            const isMobile = filterPanel.classList.contains('is-active');
            const subCat = e.currentTarget.getAttribute('data-scroll-to');

			menuFilterCats.forEach(filterCats => {
				filterCats.classList.remove('active');
			});

			e.currentTarget.classList.add('active');
        
            // If on mobile check if menu needs to be loaded in first
            if ( isMobile ) {
                const menuID = menuFilterCat.getAttribute('data-menu-id');

                if ( menuID != menusContainer.getAttribute('data-menu-id') ) {
                    removeActiveSubcatsClass(triggers);

                    const trigger = document.querySelector('.js-menu-filter-subcats-toggle[data-menu-id="'+menuID+'"]');
                    toggleSubcatsDisplay(trigger);

                    // Update menusContainer data-menu-id attribute
                    menusContainer.setAttribute('data-menu-id', menuID);

                    const loadingIcon = document.querySelector('.js-menu-category-loading');

                    // Fade out the current menu items
                    menusContainer.classList.add('fade-out');
                    
                    // Show the loading icon
                    loadingIcon.classList.add('is-active');

                    setTimeout(() => {        
                        //Close the popup
                        filterPanel.classList.remove('is-active');
                        document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');
                    }, 400);

                    setTimeout(() => {
                        // Load in clicked on menu items via ajax
                        const getFetchData = () => {
                            const formData = new FormData();
                            formData.append('location_id', document.getElementById('menu_location').value);
                            formData.append('menu_id', menuID);
                            formData.append('action', 'create_menu_category_ajax');
                                
                            const ajaxData = new URLSearchParams(formData);
            
                            return ajaxData;
                        }
            
                        const data = getFetchData();
            
                        fetch(window.igMenusAjaxUrl, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Cache-Control': 'no-cache',
                            },
                            body: data
                        })
                        .then((response) => response.text())
                        .then((data) => {
                            menusContainer.innerHTML = data;
                            loadingIcon.classList.remove('is-active');

                            // Re-run the dietary requirements filter functionality
                            filterMenuItemsByDietaryRequirement();

                            // Fade In new menu items
                            menusContainer.classList.remove('fade-out');
                        }).then((data) => {                        
                            window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
                        })
                        .catch((error) => {
                            loadingIcon.classList.remove('is-active');
                            console.error(error);
                        });                         
                    }, 425);              
                } else {
                    filterPanel.classList.remove('is-active');
                    document.querySelector('.menu__filter-panel__overlay').classList.remove('is-active');

                    window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
                }
            } else {
                window.scrollTo({top: getSubcatTopPos(subCat), behavior: 'smooth'});
            }
		});
	});
}

function getSubcatTopPos(subCat) {
    const subCatItems = document.querySelector('[data-scroll-key="'+subCat+'"]');
    const subCatItemsOffset = getOffsetTop(subCatItems) - 200;

    return subCatItemsOffset;
}

scrollToCat();

export const scrollToMenuTop = () => {

    const menuFilters = document.querySelector('.menu__sticky-bar');
            
    let menuFiltersStyles = window.getComputedStyle(menuFilters);
    let menuFiltersmargin = parseFloat(menuFiltersStyles['marginTop']) + parseFloat(menuFiltersStyles['marginBottom']);
    let menuFiltersHeight = Math.ceil(menuFilters.offsetHeight + menuFiltersmargin);
    let headerHeight = Math.ceil(document.querySelector('.header').offsetHeight);
    menuFiltersHeight = menuFiltersHeight + headerHeight;

    const menuItems = document.querySelector('.menu__items');
    const menuItemsOffset = menuItems.getBoundingClientRect().top + window.scrollY;
    const scrollToMenu = menuItemsOffset - menuFiltersHeight;

    window.scrollTo({top: scrollToMenu, behavior: 'instant'});
}